<mat-label class="subHeading">Vendor Premium<span class="star">*</span></mat-label>
<input formControlName="vendor_premium" class="rule mt-2" id="vendor_form"/>

